
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import moment from "moment";

  import PageHeadIcon from "@/components/page/PageHeadIcon.vue";
  import PageHeadContainer from "@/components/page/PageHeadContainer.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import ClockIcon from "@/components/icons/ClockIcon.vue";
  import CalendarIcon from "@/components/icons/CalendarIcon.vue";
  import LocationIcon from "@/components/icons/LocationIcon.vue";
  import UserIcon from "@/components/icons/UserIcon.vue";
  import CardInfoChip from "@/components/card/CardInfoChip.vue";

  import { Project } from "@/generated/graphql";
  import getLocationInfo from "@/helpers/locations/getLocationInfo";

  @Component({
    components: {
      PageHeadIcon,
      PageHeadContainer,
      UiButton,
      ClockIcon,
      CalendarIcon,
      LocationIcon,
      UserIcon,
      CardInfoChip,
    },
  })
  export default class ProjectHeader extends Vue {
    @Prop({ type: Object, required: true }) readonly project!: Project;
    @Prop({ type: String, required: true }) readonly userRole!: string;

    statusProcessing: boolean = false;

    get period(): string {
      const startDate = moment(this.project.start_date).format("DD MMM");
      const endDate = moment(this.project.end_date).format("DD MMM, YYYY");
      return `${startDate} - ${endDate}`;
    }

    get projectCompleted(): boolean {
      return this.project.completed;
    }

    get createdAt(): string {
      const date = moment(this.project.created_at).format("DD MMM, YYYY");
      return `Created At: ${date}`;
    }

    get isAdmin(): boolean {
      return this.userRole === "ADMIN";
    }

    get isContractor(): boolean {
      return this.userRole === "CONTRACTOR";
    }

    get isActionsShown(): boolean {
      return !this.isContractor;
    }

    get location(): string {
      return getLocationInfo(this.project, true);
    }


    get manager(): string {
      const firstName = this.project.manager?.user.given_name;
      const lastName = this.project.manager?.user.family_name;
      const title = "Manager:"

      if (!firstName && !lastName) {
        return `${title} -`;
      }

      return `${title} ${firstName} ${lastName}`;
    }

    @Watch("projectCompleted")
    onProjectStatusChanged(): void {
      this.statusProcessing = false;
    }

    completeProject(): void {
      this.$confirm({
        title: `Do you really want to complete the project?`,
        message: `All tasks will be closed if you complete this project`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: async (confirm: any) => {
          if (confirm) {
            this.$emit("updateProjectStatus", { completed: true, active: false });
            this.statusProcessing = true;
          }
        },
      });
    }

    reopenProject(): void {
      this.$emit("updateProjectStatus", { completed: false, active: true });
      this.statusProcessing = true;
    }
  }
